function getParam(p) {
    let match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getExpiryRecord(value) {
    let expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds

    let expiryDate = new Date().getTime() + expiryPeriod;
    return {
        value: value,
        expiryDate: expiryDate,
    };
}

function addGclid() {
    let gclidParam = getParam('gclid');
    let gclidFormFields = ['gclid_field', 'foobar']; // all possible gclid form field ids here
    let gclidRecord = null;
    let currGclidFormField;

    let gclsrcParam = getParam('gclsrc');
    let isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;

    gclidFormFields.forEach(function (field) {
        if (document.getElementById(field)) {
            currGclidFormField = document.getElementById(field);
        }
    });

    if (gclidParam && isGclsrcValid) {
        gclidRecord = getExpiryRecord(gclidParam);
        localStorage.setItem('gclid', JSON.stringify(gclidRecord));
    }

    let gclid = gclidRecord || JSON.parse(localStorage.getItem('gclid'));
    let isGclidValid = gclid && new Date().getTime() < gclid.expiryDate;

    if (currGclidFormField && isGclidValid) {
        currGclidFormField.value = gclid.value;
    }
}

window.addEventListener('load', addGclid);


// WEBPACK FOOTER //
// ./scripts/util/gclid.js